__turbopack_context__.v({
  "header-content-mobile": "wdJxRa_header-content-mobile",
  "header-content-mobile__logo-container": "wdJxRa_header-content-mobile__logo-container",
  "header-content-mobile__notifications-modal-trigger-container": "wdJxRa_header-content-mobile__notifications-modal-trigger-container",
  "language-button": "wdJxRa_language-button",
  "language-button__icon": "wdJxRa_language-button__icon",
});
